
import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_1/BuildingInstructions_Images/ExplorationModels`

const Pic1 = `${FullPath}/PerimeterRollingAndSliding/BigPerimeter/1_1x.png`;
const Pic2 = `${FullPath}/PerimeterRollingAndSliding/BigPerimeter/2_1x.png`;
const Pic3 = `${FullPath}/PerimeterRollingAndSliding/BigPerimeter/3_1x.png`;
const Pic4 = `${FullPath}/PerimeterRollingAndSliding/BigPerimeter/4_1x.png`;
const Pic5 = `${FullPath}/PerimeterRollingAndSliding/BigPerimeter/5_1x.png`;
const Pic6 = `${FullPath}/PerimeterRollingAndSliding/BigPerimeter/6_1x.png`;
const Pic7 = `${FullPath}/PerimeterRollingAndSliding/BigPerimeter/7_1x.png`;
const Pic8 = `${FullPath}/PerimeterRollingAndSliding/BigPerimeter/8_1x.png`;
const Pic9 = `${FullPath}/PerimeterRollingAndSliding/BigPerimeter/9_1x.png`;
const Pic10 = `${FullPath}/PerimeterRollingAndSliding/BigPerimeter/10_1x.png`;
const Pic11 = `${FullPath}/PerimeterRollingAndSliding/BigPerimeter/11_1x.png`;


export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}